// @flow
import { get } from 'lodash';

import appConfig from 'Config';
import { isSeller } from 'Utils/seller/sellerUtils';

type KeyInfo = {
  b2cKey: string,
  b2cLegacyMobileKey: string,
  b2cMobileKey: string,
  b2cDesktopKey: string,
  sellerKey: string,
};

function _getKey(locale: string) {
  return (...paths: Array<string>): * => {
    return !!paths.reduce((resolved, currentPath) => {
      return typeof resolved !== 'boolean' ? appConfig.get(currentPath, locale) : resolved;
    }, null);
  };
}

function getKeyInfo(key): KeyInfo {
  return {
    b2cKey: `featureFlipping.${key}`,
    b2cLegacyMobileKey: `featureFlipping.mobile.${key}`,
    b2cMobileKey: `featureFlipping.${key}.mobile`,
    b2cDesktopKey: `featureFlipping.${key}.desktop`,
    sellerKey: `featureFlipping.seller.${key}`,
  };
}

export function isFeatureFlipped(appContext: AppContext, isMobile?: boolean = false): string => * {
  return key => {
    const locale = get(appContext, 'locale');
    const getKey = _getKey(locale);
    const { b2cKey, b2cDesktopKey, b2cLegacyMobileKey, b2cMobileKey, sellerKey } = getKeyInfo(key);

    if (isSeller(appContext)) {
      return getKey(sellerKey, b2cKey);
    }
    return isMobile
      ? getKey(b2cMobileKey, b2cLegacyMobileKey, b2cKey)
      : getKey(b2cDesktopKey, b2cKey);
  };
}
